import styled, {css} from 'styled-components';
import MyLoginSVG from '../../assets/onboarding/my-login.svg';

const MyLoginIcon = styled(MyLoginSVG as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.3rem'};
  height: ${props => props.height || '2.3rem'};
  fill: ${props => props.fill || props.theme.colors.blue.brand};
`;

export default MyLoginIcon;
